import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import '@splidejs/react-splide/css';
// or other themes
import '@splidejs/react-splide/css/skyblue';
import '@splidejs/react-splide/css/sea-green';

import './carouselcomponent.scss';

const CarouselComponent = () => {
  // Data for images and links
  const slides = [
    { id: 1, imgSrc: './assets/images/carousel_image/Cosmos_Journey.jpg', link: 'https://example.com/1' },
    { id: 2, imgSrc: './assets/images/carousel_image/Sunset_at_beach.jpg', link: 'https://example.com/2' },
    { id: 3, imgSrc: './assets/images/carousel_image/tanqual_temple.jpg', link: 'https://example.com/3' },
    { id: 4, imgSrc: './assets/images/carousel_image/Starry-NightSky.jpg', link: 'https://example.com/4' },
    { id: 5, imgSrc: './assets/images/carousel_image/RiversideSerenity.jpg', link: 'https://example.com/5' },
    // { id: 6, imgSrc: './assets/images/carousel_image/tanqual_temple.jpg', link: 'https://example.com/6' },
  ];


  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    // Your custom logic here
    console.log('Link clicked without navigating');
  };

  return (
    <Splide
      options={{
        type: 'loop',         // Enable looping
        drag: 'free',         // Enable free dragging
        focus: 'center',      // Focus the current slide at the center
        perPage: 4,           // Show 3 slides at a time
        gap: '2rem',          // Gap between slides
        pagination: true,     // Enable pagination dots
        arrows: false,         // Enable navigation arrows
        autoScroll: {
          speed: 0.2,       // AutoScroll speed (adjust for slower/faster)
          pauseOnHover: true, // Pause auto-scroll on hover
          pauseOnFocus: false, // Don't pause on focus
        },
        breakpoints: {
            768: {
              perPage: 2,       // For smaller screens
            },
            480: {
              perPage: 1,       // For very small screens
            },
          },
      }}
      extensions={{ AutoScroll }}
      aria-label="Splide Carousel"
    >
      {slides.map((slide) => (
        <SplideSlide key={slide.id}>
          {/* <a href={slide.link} target="_blank" rel="noopener noreferrer">
            <img src={slide.imgSrc} alt={`Slide ${slide.id}`} style={{ width: '100%' }} />
          </a> */}

          <a  >
            <img src={slide.imgSrc} alt={`Slide ${slide.id}`} style={{ width: '100%' }} />
          </a>
        </SplideSlide>
      ))}
    </Splide>
  );
};

export default CarouselComponent;
